import { CALL_API } from '../../util/RBRestMiddleware'
import NgrxAuth from '../../auth/Auth'

export const RESOURCE_LOADING = 'RESOURCE_LOADING'
export const RESOURCE_SUCCESS = 'RESOURCE_SUCCESS'
export const RESOURCE_FAILED = 'RESOURCE_FAILED'

export const downloadResource = (resourceType, onSuccess, onError) => {
  return dispatch => {
    dispatch({
      [CALL_API]: {
        path: `/resources/${NgrxAuth.memberId}/${resourceType}`,
        prefix: 'RESOURCE',
        onSuccess,
        onError
      }
    })
  }
}



// WEBPACK FOOTER //
// ./src/redux/actions/resourcesActions.js